<ion-content class="app-page">
  <div class="auth-screen">
    <section class="hero-copy">
      <p class="eyebrow">Launch Faster</p>
      <h1 class="hero-title">Turn a blank account into a messaging operation in one guided flow.</h1>
      <p class="subtle-copy">
        Start with your business details, connect Meta, activate coexistence, then move straight into
        templates and campaign dispatch.
      </p>
    </section>

    <section class="glass-panel auth-card">
      <p class="eyebrow">Create Workspace</p>
      <h2 class="section-title">Start your starter platform</h2>

      <div [formGroup]="form">
        <div class="form-grid">
          <ion-item>
            <ion-label position="stacked">First name</ion-label>
            <ion-input formControlName="first_name"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Last name</ion-label>
            <ion-input formControlName="last_name"></ion-input>
          </ion-item>
        </div>

        <ion-item>
          <ion-label position="stacked">Email</ion-label>
          <ion-input type="email" formControlName="email"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Password</ion-label>
          <ion-input type="password" formControlName="password"></ion-input>
        </ion-item>

        <ion-text color="danger" *ngIf="errorMessage">{{ errorMessage }}</ion-text>

        <ion-button expand="block" (click)="submit()" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Creating account...' : 'Register' }}
        </ion-button>
      </div>

      <p class="subtle-copy auth-foot">
        Already have an account?
        <a routerLink="/auth/login">Sign in</a>
      </p>
    </section>
  </div>
</ion-content>
